import {useQuery} from "react-query";
import axios from "axios";
import {PagedSearchParams} from "@atiautomacao/ati-ui-library";

const apiUrl = "api/command-history/grid";

const fetchCommandHistory = async (pagedSearchParams: PagedSearchParams, powerStationIds?: number[] | null) => {
    try {
        const params = pagedSearchParams ? pagedSearchParams.toURLSearchParams() : new URLSearchParams();
        if (powerStationIds && powerStationIds.length > 0) {
            powerStationIds.forEach((id) => params.append("powerStationIds", String(id)));
        }
        const response = await axios
            .get(apiUrl, {
                params
            })
            .then((res) => res.data);

        return response ?? 0;
    } catch (error : any) {
        console.error("Error fetching data:", error);
        return 0;
    }
};

export const CommandHistory = (pagedSearchParams: PagedSearchParams, isAuthenticated:boolean, isAuthorizedToShowGrid: boolean, interval?: number, powerStationIds?: number[] | null) => {
    return useQuery({
        queryKey: ["data", pagedSearchParams, powerStationIds],
        queryFn: () => fetchCommandHistory(pagedSearchParams, powerStationIds),
        refetchInterval: interval ?? false,
        enabled: isAuthenticated && isAuthorizedToShowGrid, // Apenas ativa a query se ambas as condições forem verdadeiras
    });
};
